import { Component } from '@angular/core';

@Component({
  selector: 'app-pre-auth-layout',
  templateUrl: './pre-auth-layout.component.html',
  styleUrls: [ './pre-auth-layout.component.scss' ]
})
export class PreAuthLayoutComponent {
}
